import { useReduxAuth } from "./useReduxAuth";

export const useReduxAuthToken = (): string | undefined => {
  const reduxAuth = useReduxAuth();

  return reduxAuth?.identity?.accessToken ?? undefined;
};
